// Tanner Fry
// tannerf1101@yahoo.com
// Action panel to handle keys pressed throughout the app.

import _settings from "../../../AppSettings";
import "../../css/components/ActionPanel.css";

import { useCallback, useEffect, useState } from "react";

const ActionPanel = (props) => {
    const [isDevBoxEnabled, setIsDevBoxEnabled] = useState(false);

    useEffect(() => {
        // console.log("isDevBoxEnabled: ", isDevBoxEnabled);
    }, [isDevBoxEnabled]);

    const keyPressedFunction = useCallback((event) => {
        if (event.key === "Escape") {
            //Do whatever when esc is pressed
        }
         if (event.key === "`") {
            // Enable dev box            
            setIsDevBoxEnabled(true);
        } else if (event.key === "~") {
            setIsDevBoxEnabled(false);
        }
    }, []);
  
    useEffect(() => {        
        window.addEventListener("keydown", keyPressedFunction, true);
    
        return () => {
            window.removeEventListener("keydown", keyPressedFunction, true);
        };
    }, [keyPressedFunction]);
  
    return (   
        <>
            {isDevBoxEnabled && (
                <div className="action-panel">
                    <div className="dev-box">
                        <section className="app-stats">
                            <h3>App Info</h3>
                            <p>App Version: {process.env.REACT_APP_VERSION}</p>
                            <p>App Environment: {_settings.ENVIRONMENT}</p>
                            <p>Mobile Enabled: {String(_settings.ENABLE_MOBILE)}</p>
                            <p>Window Width: {window.innerWidth}px</p>
                            <p>Window Height: {window.innerHeight}px</p>
                        </section>
                    </div>
                </div>
            )}
        </>
    )
};

export default ActionPanel;